import { addCommentReplyMarker } from './commentThreads'

interface ContentLink {
    url: string
    title?: string
}

interface ContentMention {
    name: string
}

export const COMMENT_MAX_LENGTH = 500
export const COMMENT_LENGTH_WARNING = 450

// The current API requires CommentCreate.content to contain at least one
// character, while attachments can only be uploaded after the comment exists.
// Keep the compatibility value invisible and strip it before rendering/editing.
export const ATTACHMENT_ONLY_COMMENT_CONTENT = '\u200B'

export const prepareCommentContentForCreate = (content: string, hasAttachments: boolean) =>
    content || (hasAttachments ? ATTACHMENT_ONLY_COMMENT_CONTENT : '')

export const stripAttachmentOnlyCommentContent = (content: string) =>
    content.replaceAll(ATTACHMENT_ONLY_COMMENT_CONTENT, '')

export const getCommentCharacterCount = (content: string) => Array.from(content).length

export const serializeCommentContent = (
    text: string,
    links: ContentLink[] = [],
    mentions: ContentMention[] = [],
    parentCommentId?: number | null,
) => {
    const parts: string[] = []
    if (text.trim()) parts.push(text.trim())
    mentions.forEach((mention) => parts.push(`@${mention.name}`))
    links.forEach((link) => parts.push(link.title ? `${link.title}: ${link.url}` : link.url))
    return addCommentReplyMarker(parts.join('\n'), parentCommentId)
}

export const isCommentTooLongError = (error: any): boolean => {
    const detail = error?.response?.data?.detail ?? error?.data?.detail ?? error?.detail
    if (!Array.isArray(detail)) return false

    return detail.some((item: any) => {
        const location = Array.isArray(item?.loc) ? item.loc.map(String) : []
        return (item?.type === 'string_too_long' && location.includes('content'))
            || /at most\s+500|500\s+characters/i.test(String(item?.msg || ''))
    })
}
